// @flow
import {Relative} from 'componentsStyled/Layout/Position';
import styled from 'styled-components';

export const SearchAutocompleteWrap = styled(Relative)`
  flex-grow: 1;
  max-width: 42rem;
`;
